export class CommonTablesDataService {
    public static updateVesselsFromErp(callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/commontables/vessel/updatefromerp`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static updateCustomersFromErp(callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/commontables/customer/updatefromerp`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static updateDepartmentsFromErp(callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/commontables/department/updatefromerp`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}